<template>
    <div class="form-group" :class="{'has-error': hasError}">
        <label :for="name" class="control-label" :class="'col-sm-' + labelWidth" v-if="label">
            {{ label }}
        </label>

        <div :class="'col-sm-' + inputWidth">
            <slot></slot>

            <span class="help-block" v-if="hasHelpText">
                {{ helpText }}
            </span>

            <span class="help-block" v-if="hasError">
                {{ error }}
            </span>
        </div>

        <div :class="'col-sm-' + buttonWidth">
            <button
                    type="button"
                    class="btn btn-block btn-black"
                    v-html="buttonText"
                    :disabled="disabled"
                    @click="$emit('click')"
            >
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            "name": {},
            "label": {},
            "helpText": {"default": null},
            "error": {"default": null},
            "labelWidth": {"default": 8},
            "inputWidth": {"default": 12},
            "buttonWidth": {"default": 4},
            "buttonText": {"default": '<i class="fa fa-plus"></i> Create'},
            "disabled": {"default": false}
        },

        computed: {
            hasHelpText() {
                return this.helpText !== null;
            },

            hasError() {
                return this.error !== null;
            }
        }
    }
</script>
